export function GetNghiepVu(ct:any) : string[] {
    let ret =""
    let color ="blue"
    if (ct.tkNo=='111' && ct.tkCo=='131') {
        ret = 'Thu tiền'
    } else if (ct.tkNo=='131' && ct.tkCo=='111') {
        ret = 'Bù tiền'
        color='red'
    } else if (ct.tkNo=='131' && ct.tkCo=='') {
        ret = 'Phải thu'
    } else if (ct.tkNo=='' && ct.tkCo=='131') {
        ret = 'Phải trả'
        color='red'
    }
    return [ret,color]
}